import { createI18n } from 'vue-i18n'

// Import base locales from sde-client
import sdeEn from 'sde-client/locales/en-US.json'
import sdeCs from 'sde-client/locales/cs-CZ.json'
import sdeSk from 'sde-client/locales/sk-SK.json'

// Import eurodrive-app specific locale extensions
import eurodriveEn from '~/locales/en.json'
import eurodriveCs from '~/locales/cs.json'
import eurodriveSk from '~/locales/sk.json'

// Deep merge function to combine sde-client and eurodrive-app translations
function deepMerge<T extends Record<string, any>>(target: T, source: Record<string, any>): T {
  const result = { ...target } as T
  for (const key in source) {
    if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
      result[key as keyof T] = deepMerge(
        (result[key as keyof T] as Record<string, any>) || {},
        source[key]
      ) as T[keyof T]
    } else {
      result[key as keyof T] = source[key]
    }
  }
  return result
}

export default createI18n({
  legacy: false,
  locale: 'cs',
  fallbackLocale: 'en',
  messages: {
    en: deepMerge(sdeEn, eurodriveEn),
    cs: deepMerge(sdeCs, eurodriveCs),
    sk: deepMerge(sdeSk, eurodriveSk)
  }
})
